import {Button, closeCurrentDialog, FormButton, FormControl} from 'platform/components';
import {HStack} from 'platform/foundation';

import {FieldValues} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface DialogActionsProps<TValues extends FieldValues> extends RequiredTestIdProps {
  control: FormControl<TValues>;
  isLoading: boolean;
  confirmTitle?: string;
}

export function DialogActions<TValues extends FieldValues>(props: DialogActionsProps<TValues>) {
  return (
    <HStack spacing={2} justify="flex-end">
      <Button
        title={i18n.t('general.actions.discard')}
        variant="secondary"
        onClick={closeCurrentDialog}
        data-testid={suffixTestId('actions.discard', props)}
      />
      <FormButton
        control={props.control}
        type="submit"
        title={props.confirmTitle ?? i18n.t('general.actions.confirm')}
        variant="primary"
        isLoading={props.isLoading}
        data-testid={suffixTestId('actions.confirm', props)}
      />
    </HStack>
  );
}
